import React from 'react';
import { choose } from '../../utils/platform';
import { useLogin } from './useLogin';
import LoginDesktop from './Login.desktop';
import LoginMobile from './Login.mobile';

const LoginView = choose(LoginDesktop, LoginMobile);

export default function Login() {
  const vm = useLogin();
  return <LoginView vm={vm} />;
}
